(function () {
  'use strict';

  const CONFIG = {
    debug: true,
  };

  function debugLog(message, data = null) {
    if (CONFIG.debug) {
      console.log('[Custom Form Embed]', message, data || '');
    }
  }

  const sheet = new CSSStyleSheet();
  sheet.replaceSync(`
    :host {
        --container-border-radius: 0;
        --form-field-border-radius: 8px;
        --button-border-radius: 8px;
        --container-shadow: none;
        --min-form-width: 30vw;
        --spacing-size-y: 40px;
        --forms-heading-font: 'Akzidenz Regular', sans-serif !important;
        --forms-body-font: 'Akzidenz Regular', sans-serif !important;
    }
    div[class^="_formContainerCloseButtonPosition"] {
        top: calc(var(--forms-padding-top) - 12px);
    }
    section[class^="_formHeader"] {
        margin-bottom: 4rem;
    }
    h2[class^="_textHeading"] {
        margin: 1rem 2rem 2rem;
        font-size: 2rem;
    }
    div[class^="_textBody"] {
        margin: 0 8rem;
    }
    div[class^="_formPhoneInputContainer"] {
        display: flex;
        flex-direction: column;
    }
    .phone-country-selector {
        display: none;
    }
    output[class^="_formError"] {
        display: none !important;
    }
    button[class^="_formSubmitButton"] {
      border: 1px solid white;
      transition: all ease 0.5s;
    }
    button[class^="_formSubmitButton"]:hover, button[class^="_formSubmitButton"]:focus-visible, 
    button[class^="_formSubmitButton"]:active {
      filter: none;
      border: 1px solid white;
      background-color: black;
      color: white;
    }
    section[class^="_formContainer"].course-bg-black {
      background-color: white;
    }
    section[class^="_formContainer"].course-bg-black * {
      color: black;
      fill: black;
    }
    section[class^="_formContainer"].course-bg-black form button[class^="_formSubmitButton"] {
      border-color: black;
      background-color: black;
      color: white;
    }
    section[class^="_formContainer"].course-bg-black form button[class^="_formSubmitButton"]:hover, 
    section[class^="_formContainer"].course-bg-black button[class^="_formSubmitButton"]:focus-visible, 
    section[class^="_formContainer"].course-bg-black button[class^="_formSubmitButton"]:active {
      border-color: black;
      background-color: white;
      color: black;
    }
    section[class^="_formContainer"].course-bg-black form input {
      box-shadow: 0 0 0 1px #000000A6;
    }
    section[class^="_formContainer"].course-bg-black form input:focus, 
    section[class^="_formContainer"].course-bg-black form textarea:focus-visible {
      box-shadow: 0 0 0 2px #000;
    }
    @media screen and (max-width: 1650px) {
      h2[class^="_textHeading"] {
        margin-left: 0;
        margin-right: 0;
      }
      div[class^="_textBody"] {
        margin-left: 0;
        margin-right: 0;
      }
    }

`);

  function applyStyleToFormEmbed(form) {
    if (!form.id.includes('677356')) return;

    debugLog(`Found form embed`, form);

    const shadowRoot = form.shadowRoot;

    if (shadowRoot && !shadowRoot.adoptedStyleSheets.includes(sheet)) {
      if (document.body.classList.contains('course-bg-black')) {
        debugLog('Adding course-bg-black class to form container');
        shadowRoot.querySelector('[class^="_formContainer"]').classList.add('course-bg-black');
      }

      shadowRoot.adoptedStyleSheets.push(sheet);
      debugLog('Styles applied to shadow root');
    } else if (!shadowRoot) {
      debugLog('No shadow root found, retrying...');
      setTimeout(() => applyStyleToFormEmbed(form), 100);
    }
  }

  function findAndStyleForm() {
    const formsEmbed = document.querySelector('shopify-forms-embed');
    if (formsEmbed) {
      applyStyleToFormEmbed(formsEmbed);
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    findAndStyleForm();

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('shopify-forms-embed')) {
              applyStyleToFormEmbed(node);
            }
            const shopifyEmbed = node.querySelector && node.querySelector('shopify-forms-embed');
            if (shopifyEmbed) {
              applyStyleToFormEmbed(shopifyEmbed);
            }
          }
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  debugLog('Script customizado Form Embed inicializado');
})();
